module.exports = __webpack_public_path__ + "static/media/122.a1aa3ffb.jpg";